export default "__VITE_ASSET__Bbn957yV__"